import React from 'react';
import { COMPANY_INFO, getFormattedAddress } from '../../utils/companyInfo';

export default function SiteFooter({ showExtendedFooter = false }) {
  return (
    <footer id="footer" className="footer simple">
      <div className="container">
        <p>
          &copy; {COMPANY_INFO.name} {new Date().getFullYear()}, {getFormattedAddress('singleLine')}
          <span className="footer-links">
            <a href="https://timepayment.com/terms/" target="_blank" rel="noopener noreferrer">
              Terms &amp; Conditions
            </a>{' '}
            |{' '}
            <a href="https://timepayment.com/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </span>
        </p>

        {showExtendedFooter ? (
          <p>
            For California Customers:{' '}
            <a href="https://timepayment.com/ca-privacy-notice/" rel="noopener noreferrer" target="_blank">
              https://timepayment.com/ca-privacy-notice/
            </a>
          </p>
        ) : null}
      </div>
    </footer>
  );
}
